import { createRoute } from "@tanstack/react-router";
import { CasePublishPanel } from "@/components/case-publish-panel";
import { useCaseDetail } from "@/hooks/use-case-detail";
import { versionLayoutRoute } from "./version-layout-route";

export const versionPublishRoute = createRoute({
  getParentRoute: () => versionLayoutRoute,
  path: "/publish",
  component: VersionPublishPage,
});

function VersionPublishPage() {
  const { caseId, versionId } = versionPublishRoute.useParams();
  const detailQuery = useCaseDetail(caseId);

  if (!detailQuery.data) return null;

  const versions = detailQuery.data.versions;
  const sourceVersion =
    versions.find((v) => v.id === versionId) ??
    versions.find((v) => v.phoneJsonR2Key) ??
    null;

  return (
    <CasePublishPanel
      caseId={caseId}
      versions={versions}
      sourceVersion={sourceVersion}
      singleVersion
    />
  );
}
